import type { QuoteReviewPublic } from "@common/client"

export const REVIEW_TABS = ["tasks", "findings", "letter", "terms"] as const

export type ReviewTab = (typeof REVIEW_TABS)[number]

export function tabLabel(tab: ReviewTab): string {
  switch (tab) {
    case "tasks":
      return "Tasks"
    case "findings":
      return "Findings"
    case "letter":
      return "Proposal letter"
    case "terms":
      return "Terms & conditions"
  }
}

export function availableTabs(review: QuoteReviewPublic): ReviewTab[] {
  return REVIEW_TABS.filter((tab) => {
    switch (tab) {
      case "tasks":
        return true
      case "findings":
        return review.findings.length > 0
      case "letter":
        return review.proposal_letter !== null
      case "terms":
        return review.terms_and_conditions !== null || review.terms_url !== null
    }
  })
}
